import React, { useEffect, useState } from '../../../../_snowpack/pkg/react.js';
import { CostInfo, HeadingSubtitleImg, Plan, PlanName, Pricing, PricingMetaText, PricingPlanImg } from './styles.js'; // @ts-ignore

import { colors } from '../../../css/index.js';
import { FeatureSet } from './feature-set.js';
import { ChoosePlan } from './plan-action-button.js';
import { SubscriptionChange } from './create-crystallize-subscription/interfaces.js';
import { ADD_CREDIT_CARD, CHOOSE_THIS_PLAN } from './create-crystallize-subscription/constants.js';
import { useTenant } from '../../../hooks/index.js';
export const PricingPlan = ({
  pricingPlan,
  activeProdSubId,
  paymentMethodExist,
  disableButton,
  buttonLabel,
  onChangePlanOnly
}) => {
  const {
    tenant
  } = useTenant();
  const [url, setUrl] = useState(``);
  const [subscriptionOp, setSubscriptionOp] = useState(SubscriptionChange.KeepCurrentPlanUnchanged);
  const activeSubWithCreditCard = activeProdSubId.length > 0 && paymentMethodExist;
  const activeSubWithoutCreditCard = activeProdSubId.length > 0 && !paymentMethodExist;
  const noActiveSubAndCreditCard = !activeProdSubId && !paymentMethodExist;
  const isAtomButton = pricingPlan.name.toLowerCase() === 'atom';
  const isParticleButton = pricingPlan.name.toLowerCase() === 'particle'; // eslint-disable-next-line react-hooks/exhaustive-deps

  const setOpAndUrlForButtonAction = () => {
    if (buttonLabel === CHOOSE_THIS_PLAN && activeSubWithCreditCard) {
      if (isAtomButton) setSubscriptionOp(SubscriptionChange.UpgradeParticleToAtomWithoutPayment);
      if (isParticleButton) setSubscriptionOp(SubscriptionChange.DowngradeAtomToParticleWithoutPayment);
    }

    if (buttonLabel === CHOOSE_THIS_PLAN && activeSubWithoutCreditCard) {
      if (isAtomButton) setSubscriptionOp(SubscriptionChange.UpgradeParticleToAtomWithPayment);
      if (isParticleButton) setSubscriptionOp(SubscriptionChange.DowngradeAtomToParticleWithPayment);
      setUrl(`/settings/tenants/${tenant.identifier}/add-payment`);
    }

    if (buttonLabel === ADD_CREDIT_CARD && activeSubWithoutCreditCard) {
      setSubscriptionOp(SubscriptionChange.AddPaymentToCurrentSubscription);
      setUrl(`/settings/tenants/${tenant.identifier}/add-payment`);
    }

    if (noActiveSubAndCreditCard) {
      setSubscriptionOp(SubscriptionChange.CreateNewSubscription);
      setUrl(`/settings/tenants/${tenant.identifier}/plans/activate-subscription`);
    }
  };

  useEffect(() => {
    setOpAndUrlForButtonAction();
  }, [setOpAndUrlForButtonAction]);
  return /*#__PURE__*/React.createElement(Plan, null, /*#__PURE__*/React.createElement(HeadingSubtitleImg, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanName, {
    as: 'h2',
    plan: pricingPlan.name.toLowerCase()
  }, pricingPlan.name), /*#__PURE__*/React.createElement("p", {
    style: {
      color: `${colors.frostbite}`
    }
  }, pricingPlan.subHeading)), /*#__PURE__*/React.createElement(PricingPlanImg, {
    src: pricingPlan.image,
    alt: pricingPlan.name
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CostInfo, null, /*#__PURE__*/React.createElement(Pricing, null, pricingPlan.priceInfo.price), /*#__PURE__*/React.createElement(PricingMetaText, null, pricingPlan.priceInfo.meta)), /*#__PURE__*/React.createElement(ChoosePlan, {
    buttonLabel: buttonLabel,
    planName: pricingPlan.name.toLowerCase(),
    disabled: disableButton,
    linkUrl: url,
    activeProdSubId: activeProdSubId,
    subscriptionOp: subscriptionOp,
    onChangePlanOnly: onChangePlanOnly
  })), /*#__PURE__*/React.createElement(FeatureSet, {
    features: pricingPlan.features
  }));
};